import { trans } from '@lingoda/i18n';
import { Button } from '../buttons/Button';
import { ArrowLeftIcon } from '../icons/lingodaIcons';
import { Box, type BoxProps } from './Box';
import type { ButtonProps } from '../buttons/Button';

type Props = {
    goBack: () => void;
    barSx?: BoxProps['sx'];
} & Pick<ButtonProps, 'inverted'>;

export const BackButtonBar = ({ goBack, inverted, barSx }: Props) => {
    return (
        <Box sx={{ mt: 2, ml: { xs: -1, md: -2 }, ...barSx }}>
            <Button
                color="primary"
                startIcon={<ArrowLeftIcon size={24} />}
                onClick={goBack}
                size="small"
                {...(inverted ? { inverted: true, variant: 'outlined' } : {})}
            >
                {trans('btn-back', {}, 'student-notification')}
            </Button>
        </Box>
    );
};
